import React, { useEffect, useState, useRef } from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, ExclamationCircleFilled, FileProtectOutlined } from '@ant-design/icons';
import { Table, Empty, Modal, Form, Divider, Button, message, Space, Skeleton, Tag } from 'antd';
import { getAll, insert, update, drop } from '../../../../apis/DefinicionAutorizacionApi';
import AnioPreNomina from '../../../../components/forms/anio_prenomina';
import useCookies from "../../../../hooks/useCookies";
import FormBody from './form'
import TIPO_AUTORIZACION_OPTIONS, { getTipoAutorizacionText, getTipoAutorizacionColor } from '../../../../constants/tipoAutorizacion';
import moment from 'moment';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [
    {
        href: '',
        title: <>
            <HomeOutlined />
            <span>Inicio</span>
        </>,
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Asistencia</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Empleados</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <FileProtectOutlined />
                <span>Autorizaciones por Empleado</span>
            </>
        ),
    }
];

const DefinicionAutorizacionPage = () => {
    const [empleadoCookie] = useCookies("empleado_id");
    const [form] = Form.useForm()
    const [ID, setID] = useState(null);
    const [items, setItems] = useState([]);
    const [objectSelected, setObjectSelected] = useState(null);
    const [disabledForm, setDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [period, setPeriod] = useState(null);
    const [periodDetail, setPeriodDetail] = useState(null);
    const [periodData, setPeriodData] = useState(null);
    const [status, setStatus] = useState(null);
    const [header, setHeader] = useState(null);
    const anioPrenominaRef = useRef(null);

    useEffect(() => {
        (async () => {
          if (empleadoCookie?.value > 0) {
            var _header = { ...header, odoo_empleado_id: empleadoCookie?.value };
            setHeader(_header)
          }
        })();
      }, [empleadoCookie]);

    useEffect(() => {
        refreshData();
    }, []);

    const columns = [
        {
            title: 'Empleado',
            dataIndex: ['empleado', 'name'],
            key: 'empleado',
        },
        {
            title: 'Fecha',
            dataIndex: 'fecha',
            key: 'fecha',
            render: (fecha) => fecha ? moment(fecha).format('DD/MM/YYYY') : 'N/A'
        },
        {
            title: 'Tipo Autorización',
            dataIndex: 'tipo_autorizacion',
            key: 'tipo_autorizacion',
            render: (tipo_autorizacion) => (
                <Tag color={getTipoAutorizacionColor(tipo_autorizacion)}>
                    {getTipoAutorizacionText(tipo_autorizacion)}
                </Tag>
            )
        },
        {
            title: 'Motivo',
            dataIndex: ['motivo', 'name'],
            key: 'motivo',
            render: (motivo) => motivo || 'N/A'
        },
        {
            title: 'Comentarios',
            dataIndex: 'comentarios',
            key: 'comentarios',
            render: (comentarios) => comentarios || '-'
        },
        {
            title: 'Autorizo',
            dataIndex: 'created_by',
            key: 'created_by',
            render: (created_by) => created_by?.name || 'N/A'
        },
        {
            title: 'Última modificación',
            key: 'ultima_modificacion',
            render: (record) => {
                if (record.user_updated && record.date_updated) {
                    const userName = record.updated_by?.name || 'N/A';
                    const date = moment(record.date_updated).format('DD/MM/YYYY HH:mm');
                    return (
                        <div>
                            <div><strong>{userName}</strong></div>
                            <div style={{ fontSize: '12px', color: '#888' }}>{date}</div>
                        </div>
                    );
                }
                const userName = record.created_by?.name || 'N/A';
                const date = record.date_created ? moment(record.date_created).format('DD/MM/YYYY HH:mm') : 'N/A';
                return (
                    <div>
                        <div><strong>{userName}</strong></div>
                        <div style={{ fontSize: '12px', color: '#888' }}>{date}</div>
                    </div>
                );
            }
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            render: (item, object) => {
                return <Space>
                    <Button type='primary' size='small' onClick={() => {
                        onEdit(object);
                    }}>Editar</Button>
                    <Button type='primary' size='small' danger onClick={() => {
                        deleteConfirm(object);
                    }}>Eliminar</Button>
                </Space>
            }
        }
    ];

    const bodyRef = React.createRef();

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            console.log('[DEBUG] handleOk - form values', values);
            if (!values) return;

            // Convertir el moment a fecha ISO antes de enviar
            const payload = {
                ...values,
                fecha: values.fecha ? values.fecha.format('YYYY-MM-DD') : null,
                valor: values.hora || 0
            };
            delete payload.hora;
            console.log('[DEBUG] handleOk - payload a enviar', payload);

            let success = false;

            if (objectSelected?.id > 0) {
                //Update
                payload.id = objectSelected?.id;
                console.log('[DEBUG] handleOk - UPDATE', { id: payload.id });
                const response = await update(payload);
                console.log('[DEBUG] handleOk - UPDATE response', response);
                success = response.ok;
                if (response.ok) {
                    message.success('Se actualizó correctamente la definición de autorización!');
                }
            } else {
                //Create
                console.log('[DEBUG] handleOk - CREATE');
                const response = await insert(payload);
                console.log('[DEBUG] handleOk - CREATE response', response);
                success = response.ok;
                if (response.ok) {
                    message.success('Se guardó correctamente la definición de autorización!');
                }
            }

            if (success) {
                await resetBody();
                await refreshData();
            }
        } catch (errorInfo) {
            console.log('[DEBUG] handleOk - ERROR', errorInfo);
            if (errorInfo?.response) {
                console.log('[DEBUG] handleOk - error response', errorInfo.response);
            }
            if (errorInfo?.message) {
                console.log('[DEBUG] handleOk - error message', errorInfo.message);
            }
            message.error('Por favor completa todos los campos obligatorios.');
            return;
        }
    }

    const resetBody = async () => {
        setObjectSelected(null);
        form.resetFields(['empleado_id', 'fecha', 'tipo_autorizacion', 'hora', 'motivo_id', 'comentarios']);
    }

    const onEdit = async (object) => {
        setObjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar la definición de autorización?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: () => { deleteOk(item.id) },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id) => {
        setLoading(true);
        const response = await drop(id);
        if (response.ok) {
            message.success('¡La definición de autorización ha sido eliminada!');
        }
        await refreshData();
    }

    const refreshData = async () => {
        setLoading(true);
        const response = await getAll();
        if (response.ok) {
            let items = response.payload;
            setItems(items);
        }
        setLoading(false);
    }

    const onBlurHeader = async (values, dataPeriod, status) => {
        console.log('[DEBUG] onBlurHeader called', { values, dataPeriod, status });
        setHeader(values)
        if (values?.anio && values?.num_periodo && values?.periodo_id) {
        setDisabled(false);
        console.log('[DEBUG] Periodo completo, habilitando formulario');
        } else {
        setDisabled(true);
        console.log('[DEBUG] Periodo incompleto, deshabilitando formulario');
        }
        setPeriodData(dataPeriod);
        setStatus(status?.value);
    }

    const getPeriodDetails = async (periodDetails) => {
        console.log('[DEBUG] getPeriodDetails', periodDetails);
        setPeriodDetail(periodDetails);
    }

    return <PageApp
        routes={routes}
        title={'Autorizaciones por Empleado'}>
        <>
            <AnioPreNomina ref={anioPrenominaRef} onBlur={onBlurHeader} getPeriodDetails={getPeriodDetails} form={form} disabledForm={objectSelected && objectSelected.id > 0} />
            <Divider />
            {
                objectSelected && objectSelected.id > 0 &&
                <FormBody ref={bodyRef} onOk={handleOk} onCancel={resetBody} form={form} disabledForm={disabledForm} object={objectSelected} period={periodData}/>
            }
            {
                !objectSelected &&
                <FormBody ref={bodyRef} onOk={handleOk} form={form} disabledForm={disabledForm} period={periodData}/>
            }
            <Divider />
        </>

        {
            loading ?
                <Skeleton loading={loading} /> :
                <>
                    {
                        items.length == 0 ? <Empty /> :
                            <Table dataSource={items} columns={columns} />
                    }
                </>
        }
    </PageApp>
}

export default DefinicionAutorizacionPage;